import React, { useState } from 'react';
import { IModalStepByStepCard } from '@/components/StepByStepCard';
import MainContainer from '@/layouts/MainContainer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box,
  Modal,
  Typography,
  IconButton,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { RegisterCompanySteps, View } from './View';

interface IRegisterCompanyProps extends IModalStepByStepCard {
  isEditingCompany?: boolean;
}

const RegisterCompany = ({
  isOpen,
  closeModal,
  onSuccess,
  isEditingCompany,
}: IRegisterCompanyProps) => {
  const [currentStep, setCurrentStep] = useState<RegisterCompanySteps>(
    isEditingCompany
      ? RegisterCompanySteps.SELECT_COMPANY
      : RegisterCompanySteps.HOME
  );

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  const backStep = () => {
    if (
      (!isEditingCompany && currentStep !== RegisterCompanySteps.HOME) ||
      (isEditingCompany && currentStep !== RegisterCompanySteps.SELECT_COMPANY)
    ) {
      return setCurrentStep(prevState => prevState - 1);
    }
    closeModal();
  };

  const nextStep = () => {
    if (currentStep !== RegisterCompanySteps.COMPANY_CONTACTS)
      setCurrentStep(prevState => prevState + 1);
  };

  const onEditingSuccess = () => {
    closeModal();
  };

  const onRegisterSuccess = () => {
    setCurrentStep(RegisterCompanySteps.HOME);
    onSuccess();
  };

  return (
    <Modal
      aria-labelledby="modal-my-account"
      aria-describedby="modal-my-account-description"
      open={isOpen}
      onClose={closeModal}
    >
      <Box
        sx={{ backgroundColor: '#FFF', overflowY: 'scroll', height: '100vh' }}
      >
        <Box sx={{ boxShadow: mdUp ? '0px 1px 1px rgba(0, 0, 0, 0.1)' : null }}>
          <Box padding="8px" sx={{ maxWidth: '900px', margin: '0 auto' }}>
            <IconButton onClick={backStep}>
              <ArrowBackIcon sx={{ color: '#000' }} />
            </IconButton>
          </Box>
        </Box>

        <MainContainer
          sx={{
            padding: '0 16px 38px 16px',
            minHeight: 'calc(100vh - 56px)',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            '& .submitButton': {
              width: 'min(100%, 382px)',
              marginX: 'auto',
              marginTop: mdUp ? '38px' : 'auto',
            },
          }}
        >
          {RegisterCompanySteps.HOME !== currentStep && (
            <Box
              sx={{
                width: '100%',
                display: 'grid',
                gap: '16px',
                textAlign: 'center',
                margin: '-40px 0 32px 0',
                padding: '0 12px',
              }}
            >
              <Typography variant="h6" component="h1">
                {isEditingCompany
                  ? 'Edite sua empresa'
                  : 'Configure sua empresa'}
              </Typography>
              <LinearProgress
                sx={{
                  height: '6px',
                  borderRadius: '10px',
                  backgroundColor: '#D9D9D9',
                  marginTop: mdUp ? 2 : '',
                }}
                value={25 * currentStep}
                variant="determinate"
                data-testid="bar-progress"
              />
            </Box>
          )}

          <View
            currentStep={currentStep}
            nextStep={nextStep}
            onSuccess={isEditingCompany ? onEditingSuccess : onRegisterSuccess}
            isEditingCompany={!!isEditingCompany}
          />
        </MainContainer>
      </Box>
    </Modal>
  );
};

export type { IRegisterCompanyProps };
export default RegisterCompany;
